import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useContext, useEffect, useState } from 'react';
import { Button } from "react-bootstrap";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { toast } from "react-toastify";
import { isWebView } from 'services/utils/nativeBridge';
import { openBarcodeScanner } from 'services/utils/nativeEvents/sso';
import Images from "../../../assets/images/imageData";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import ModalPop from "../../../components/sales/modal/modal";

const MaterialAction = ({
                            history,
                            match,
                            getMaterialForGateList,
                            material = [],
                            saveBarcodeHistory,
                            barcodeHistoryResponse = [],
                            saveSiteVerification,
                            siteVerification = [],
                            documentUrlData=[],
                            documentUploadUrl,
                            imageUploadUrlPublic
                        }) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [showBarCode, setShowBarCode] = useState(false);
    const [showBarCodeForMatch, setShowBarCodeForMatch] = useState([]);
    const [barcodeReplace, setBarcodeReplace] = useState([]);
    const [showModel, setShowModel] = useState([])
    const [materialName, setMaterialName] = useState('')
    const [assetsMappingDetailsId, setAssetsMappingDetailsId] = useState('')
    const [inputList, setInputList] = useState([{
        barcode: '',
        remark: '',
        id: '',
        material_id: '',
        barcode_status: '',
        status: ''
    }])
    const [materialId, setMaterialId] = useState('')
    const [formRemark, setFormRemark] = useState('')
    const [barcodeStatusCode, setBarcodeStatusCode] = useState([])
    const [scannedBarcode, setScannedBarcode] = useState([])
    const [barCodeMatched, setBarCodeMatched] = useState([])
    const [barcodeName, setBarCodeName] = useState([])
    let status = [
        'Replace_Barcode',
        'Replace_Material',
        'Lost',
        'Ok'
    ]
    const [data, setData] = useState(null);
    const [attachment, setAttachments] = useState([]);
    const [isImageRemove, setIsImageRemove] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            if(parseInt(match?.params?.gate_id) !== parseInt(window.localStorage.asset_gate_id)){
                delete window.localStorage.assets_verification_attachemnt
                delete window.localStorage.contract_assets_mapping_matched_barcode
                delete window.localStorage.bar_code_matched
                delete window.localStorage.bar_code_name
                delete window.localStorage?.assets_remark
                delete window.localStorage?.contract_assets_mapping_status_barcode
            }

            if(window.localStorage?.assets_verification_attachemnt){
                setAttachments(JSON.parse(window.localStorage.assets_verification_attachemnt));
            }

            if(window?.localStorage?.contract_assets_mapping_matched_barcode){
                setShowBarCodeForMatch(JSON.parse(window?.localStorage?.contract_assets_mapping_matched_barcode));
            }

            if(window.localStorage?.bar_code_matched){
                setBarCodeMatched(JSON.parse(window.localStorage?.bar_code_matched))
            }

            if(window.localStorage?.bar_code_name){
                setBarCodeName(JSON.parse(window.localStorage?.bar_code_name))
            }

            //contract_assets_mapping_status_barcode
            if(window.localStorage?.assets_remark){
                setFormRemark(window.localStorage?.assets_remark)
            }

            if(window.localStorage?.contract_assets_mapping_status_barcode){
                setBarcodeStatusCode(JSON.parse(window.localStorage?.contract_assets_mapping_status_barcode))
            }

            await getMaterialForGateList(match?.params?.assets_mapping_id, match?.params?.gate_id);
            window.localStorage.asset_gate_id = match?.params?.gate_id
            setIsLoading(false)
        })();
    }, []);

    // const handleShow = (i) => {
    //     showBarCodeForMatch[i] = true
    //     setShowBarCodeForMatch(showBarCodeForMatch)
    //     setTimeout(() => {
    //         setIsLoading(true)
    //         setIsLoading(false)
    //     }, 100)
    // }

    const removeBarCode = (i) => {
        // showBarCodeForMatch[i] = false
        delete barCodeMatched[i]
        delete scannedBarcode[i]
        // setShowBarCodeForMatch(showBarCodeForMatch)
        window.localStorage.bar_code_matched = JSON.stringify(barCodeMatched)
        setBarCodeMatched(barCodeMatched)
        setScannedBarcode(scannedBarcode)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 100)
    }

    const handleChange = (id, index, name) => {
        barcodeReplace[index] = id
        setBarcodeReplace(barcodeReplace)
        if (id === 1 || id === 2 || id === 3) {
            showModel[index] = true
            setShowModel(showModel)
        }

        console.log("handleChange id"+id+" index "+index+" name "+name )
        barcodeName[index] = name
        window.localStorage.bar_code_name = JSON.stringify(barcodeName)
        setBarCodeName(barcodeName)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 100)

    }

    const handleMatchBarCode = (barcode, scannedBarcode, i) => {
        console.log("barcode "+barcode+" scannedBarcode "+scannedBarcode+" i "+i)
        barCodeMatched[i] = "Matched"
        barcodeName[i] = "Ok";
        if (barcode !== scannedBarcode) {
            barCodeMatched[i] = "Not Matched"
        }

        console.log("barCodeMatched "+barCodeMatched)
        // showBarCodeForMatch[i] = false
        // setShowBarCodeForMatch(showBarCodeForMatch)
        setBarCodeMatched(barCodeMatched)
        setScannedBarcode(barcodeName)
        localStorage.setItem("bar_code_name", JSON.stringify(barcodeName));
        window.localStorage.bar_code_matched = JSON.stringify(barCodeMatched)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 100)
    }

    const handleInput = (key, value) => {
        console.log("key "+key+" value "+value)
        let list = [...inputList]

        console.log("list "+inputList)
        list[0][key] = value
        setInputList(list)
    }
    const handleContinue = async (index) => {
        setIsModalLoading(true)
        let list = [...inputList]
        console.log("assetsMappingDetailsId "+assetsMappingDetailsId+" materialId "+materialId+" barcodeReplace "+barcodeReplace[index])
        console.log("status "+JSON.stringify(status))
        list[0]['id'] = assetsMappingDetailsId
        list[0]['material_id'] = materialId
        list[0]['barcode_status'] = status[barcodeReplace[index] - 1]
        list[0]['status'] = barcodeReplace[index]
        console.log("handleContinue "+JSON.stringify(list))
        barcodeStatusCode[barcodeStatusCode.length] = {id:assetsMappingDetailsId, value:barcodeReplace[index]}
        localStorage.setItem("contract_assets_mapping_status_barcode", JSON.stringify(barcodeStatusCode));
        setBarcodeStatusCode(barcodeStatusCode)
        setIsLoading(true)
        showModel[index] = false
        setShowModel(showModel)
        scannedBarcode[index] = ''
        setScannedBarcode(scannedBarcode)
        await saveBarcodeHistory(list[0])
        setIsLoading(false)
    }

    const handleSubmitForm = async () => {
        if (formRemark === '') {
            toast.error("Remark is required")
            return false
        }

        const list = {}
        list['remark'] = formRemark
        list['assets_mapping_id'] = match?.params?.assets_mapping_id
        list['site_id'] = match?.params?.site_id
        list['barcode_status'] = barcodeStatusCode
        list['attachment'] = attachment
        let isOk = true;
        // eslint-disable-next-line array-callback-return
        barcodeName.map(val => {
            if(val !== 'Ok' && val !== 'Lost'){
                isOk = false;
            }
        })
        if(!isOk && barcodeStatusCode.length === 0){
            toast.error("Please verify material")
            return false
        }
        console.log("handleSubmitForm "+JSON.stringify(list))
        setIsLoading(true)
        await saveSiteVerification(list)
        setIsLoading(false)
    }
    const handleRejectModalHide = (index) => {
        console.log(showModel)
        showModel[index] = false

        console.log(showModel)
        setTimeout(() => {
            setIsLoading(true)
            setShowModel(showModel)
            setIsLoading(false)
        }, 100)
    }

    const handleAttachments = (index, val, key) => {

        if(!val){
            if(isImageRemove && attachment[index]){
                console.log("d")
                attachment[index][key] = ''
                window.localStorage.assets_verification_attachemnt = JSON.stringify(attachment)
            }
            setIsImageRemove(false)
            return ;
        }
        if(!attachment[index]){
            attachment[index] = {barcode: "", material:""}
        }
        attachment[index][key] = val[0]
        setAttachments(attachment)
        window.localStorage.assets_verification_attachemnt = JSON.stringify(attachment)
    }

    useEffect(() => {
        setIsModalLoading(false)
        if (Array.isArray(barcodeHistoryResponse)) {
            return
        }
        const statusCode = barcodeHistoryResponse?.status_code
        const v2Ok = Number(barcodeHistoryResponse?.status) === 0
        const msg = barcodeHistoryResponse?.response?.message || barcodeHistoryResponse?.message
        if (statusCode === 200 || v2Ok) {
            (async () => {
                    toast.success(msg)
                    setInputList([{
                        barcode: '',
                        remark: '',
                        id: '',
                        material_id: '',
                        barcode_status: '',
                        status: ''
                    }])
            })();
        } else if (statusCode === 400 || Number(barcodeHistoryResponse?.status) === 1) {
            toast.error(msg)
        }
    }, [barcodeHistoryResponse])


    useEffect(() => {
        // if (siteVerification?.response?.length>0) {
            if (siteVerification?.status_code === 200) {
                toast.success(siteVerification?.response?.message)
                window.location.href=`${baseUrl}/contract-assets-mapping`
            } else if (siteVerification?.status_code === 400) {
                toast.error(siteVerification?.response?.message)
            }
        // }
    }, [siteVerification])

    //Native Scanner
    const handleMessageFromNative = (event) => {
        const dataFromNative = event?.data;
        let arr = JSON.parse(localStorage.getItem("contract_assets_mapping_matched_barcode"));
        let status = localStorage.getItem("contract_assets_mapping_status_barcode");
        setBarcodeStatusCode(JSON.parse(status))
        setShowBarCodeForMatch(arr)
        setData(dataFromNative);
    };

    useEffect(() => {
        console.log(data)
        setTimeout(() => {
            if(data?.key != null) {
                if(data?.key === 'bar_code_replace'){
                    let isAlreadyExist = false
                    // eslint-disable-next-line array-callback-return
                    // check barcode is scanned anywhere in another material
                    scannedBarcode.map((val) => {
                        if(val === data?.barcodeData){
                            isAlreadyExist = true
                        }
                    })
                    if(isAlreadyExist){
                        toast.error("Barcode is already scanned")
                        return false
                    }else{
                        scannedBarcode[data?.index] = data?.barcodeData
                        setScannedBarcode(scannedBarcode)
                        console.log("scannedBarcode "+JSON.stringify(scannedBarcode))
                        setTimeout(() => {
                            setIsLoading(true)
                            setIsLoading(false)
                        }, 100)
                        handleInput('barcode', data?.barcodeData)
                    }
                }else{
                    // showBarCodeForMatch[data.index] = true
                    // setShowBarCodeForMatch(showBarCodeForMatch)
                    handleMatchBarCode(data?.oldBarcode, data?.barcodeData, data.index)
                }
            }
        }, 500);
    }, [data]);

    useEffect(()=>{
        window.addEventListener("message", 
            handleMessageFromNative);
    },[])

    const requestImagefromNative = async (contentStr) => {
      const { response, error } = await openBarcodeScanner();
      if (response) {
        const newContentStr = { ...contentStr,data : {...contentStr.data,
          barcodeData:response
        } }
        handleMessageFromNative(newContentStr);
      } else if (error) {
        toast.error(error);
      }
    };

    const openScanner = (key=null,index=null, oldBarcode = null) => {
        console.log("key "+key+" index "+index+"old barcode "+oldBarcode)
        if(key !== null && index !== null) {
            setData(null);
            if(key !== 'bar_code_replace'){
                setScannedBarcode(scannedBarcode)
                scannedBarcode[index] = ''
                setTimeout(() => {
                    setIsLoading(true)
                    setIsLoading(false)
                }, 100)
                localStorage.setItem("contract_assets_mapping_matched_barcode", JSON.stringify(barCodeMatched));
                localStorage.setItem("contract_assets_mapping_status_barcode", JSON.stringify(barcodeStatusCode));
            }

            const RNWebView = window?.ReactNativeWebView;
            if (RNWebView) {
                const contentStr = {
                    event: "OPEN_BAR_CODE_SCANNER",
                    data: {
                        key,index,oldBarcode
                    },
                    os: "ANDROID",
                }
                RNWebView.postMessage(JSON.stringify(contentStr));
            }

            if(isWebView){
              const contentStr = {
                event: "OPEN_BAR_CODE_SCANNER",
                data: {
                    key,index,oldBarcode
                },
                os: "ANDROID",
            }
              requestImagefromNative(contentStr);
            //   localStorage.setItem("inputListData", inputList);
            }      
        }
    };
    //End Native Scanner

    return (
        <Layout
            title={localization.material}
            isLoading={isLoading}
            isGoback={true}
        >
            <CardSection title={localization.gate}>
                <div className="details-listing">
                    <DivLayout
                        heading={localization.gate}
                        data={material?.gate_details?.lead_gate_setup_types?.name}
                    />
                    <DivLayout
                        heading={localization.gateDescription}
                        data={material?.gate_details?.lead_gate_setup_types?.description}
                    />
                    <DivLayout
                        heading={localization.identifier}
                        data={material?.gate_details?.assets_mapping_on_gate?.identifier}
                    />
                </div>
            </CardSection>
            {material && material?.mapping_details !== undefined && material?.mapping_details?.length > 0 && material?.mapping_details.map((value, index) => {
                return (
                    <CardSection title={localization.material + ' ' + (index + 1)} key={index}>
                        <div className="details-listing">
                            <DivLayout
                                heading={localization.material}
                                data={value?.gate_material?.material_name}
                            />
                            <DivLayout
                                heading={localization.invDescription}
                                data={value?.gate_material?.description}
                            />
                            <DivLayout
                                heading={localization.barcode}
                                data={value?.barcode}
                            />

                            <div className='col-md-6 pb-15'>
                                {showBarCodeForMatch[index] === true ? (
                                    <BarcodeScannerComponent
                                        width={500}
                                        height={300}
                                        onUpdate={(err, result) => {
                                            if (result?.text) {
                                                handleMatchBarCode(value.barcode, result?.text, index)
                                            }
                                        }}
                                    />
                                ) : barCodeMatched[index] !== null && barCodeMatched[index] !== '' && barCodeMatched[index] !== undefined ?
                                    <button className={`${'btn btn-sm '}${barCodeMatched[index] === "Matched" ? "btn-green" : "btn-red"}`}>{barCodeMatched[index]}
                                        <a className='remover' onClick={() => removeBarCode(index)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red"
                                                 className="bi bi-x-circle" viewBox="0 0 16 16">
                                                <path
                                                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path
                                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                            </svg>
                                        </a>
                                    </button>
                                    //handleShow
                                    : <button className='btn btn-primary btn-sm'
                                              onClick={() => openScanner('bar_code', index, value.barcode)}>{'Scan Barcode'}</button>}
                            </div>


                            <div className="col-md-6 col-sm-6" key={index+1}>
                                <div className="col-sm-6" key={index+10}>
                                    <FileUpload
                                        id={`barcode ${index}`}
                                        accept=".png,.jpg"
                                        documentUploadUrl={imageUploadUrlPublic}
                                        onChange={(val) => {handleAttachments(value?.id, val, 'barcode')}}
                                        multiple={true}
                                        prefilledFilename={attachment[value?.id] && attachment[value?.id]?.barcode ? "Barcode Image" : ""}
                                        setIsImageRemove={setIsImageRemove}
                                    >
                                  <span className="btn btn-transparent">
                                    {"Barcode"}
                                  </span>
                                    </FileUpload>
                                </div>
                                <div className="col-sm-6" key={index+11}>
                                    <FileUpload
                                        id={`material ${index}`}
                                        accept=".png,.jpg"
                                        documentUploadUrl={imageUploadUrlPublic}
                                        onChange={(val) => {handleAttachments(value?.id, val, 'material')}}
                                        multiple={true}
                                        prefilledFilename={attachment[value?.id] && attachment[value?.id]?.material ? "material Image" : ""}
                                        setIsImageRemove={setIsImageRemove}
                                    >
                                  <span className="btn btn-transparent">
                                    {"Material"}
                                  </span>
                                    </FileUpload>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <DropDownInput
                                    data={[
                                        {id: 1, name: "Replace Barcode"},
                                        {id: 2, name: "Replace Mat"},
                                        {id: 3, name: "Lost"},
                                        {id: 4, name: "Ok"}
                                    ]}
                                    label={localization.barcodeStatus}
                                    required
                                    errorMsg={localization.requiredName}
                                    getIdValue={(val) => {
                                        handleChange(val?.id, index, val?.value)
                                        setMaterialName(value?.gate_material?.material_name)
                                        setAssetsMappingDetailsId(value?.id)
                                        setMaterialId(value?.gate_material?.id)
                                    }}
                                    isStarRequired={true}
                                    disabled={barCodeMatched[index] === "Matched"}
                                    value={barCodeMatched[index] === "Matched" ? "Ok" :barcodeName[index] !== undefined ? barcodeName[index] :""}

                                />
                            </div>
                            <ModalPop
                                title={materialName}
                                show={showModel[index]}
                                handleModalHide={() => handleRejectModalHide(index)}
                                isLoading={isModalLoading}
                            >

                                {(barcodeReplace[index] !== undefined && (parseInt(barcodeReplace[index]) === 1 || parseInt(barcodeReplace[index]) === 2)) &&
                                    <>
                                        <div className='col-md-6  col-sm-6 col-xs-12 pb-15'>
                                            {showBarCode === true ? (
                                                <BarcodeScannerComponent
                                                    width={800}
                                                    height={300}
                                                    onUpdate={(err, result) => {
                                                        if (result?.text) {
                                                            setScannedBarcode(result?.text)
                                                            handleInput('barcode', result?.text)
                                                            setShowBarCode(false)
                                                        }
                                                    }}
                                                />
                                            ) : (scannedBarcode[index] !== undefined && scannedBarcode[index] !== '') ?
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <ConstantInput
                                                        label={localization.barcode}
                                                        type="text"
                                                        value={scannedBarcode[index]}
                                                        handleChange={(val) => {}}
                                                        isStarRequired={true}
                                                        disabled={true}
                                                    />
                                                </div>
                                                //setShowBarCode
                                                : <button className='btn btn-primary btn-sm'
                                                          onClick={() => openScanner('bar_code_replace', index, null)}>{'Scan Barcode'}</button>}
                                        </div>
                                    </>
                                }


                                {barcodeReplace[index] !== undefined && parseInt(barcodeReplace[index]) !== 4 &&
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <ConstantInput
                                            label={localization.remark}
                                            type="text"
                                            value={''}
                                            handleChange={(val) =>
                                                handleInput('remark', val)
                                            }
                                            isStarRequired={true}
                                        />
                                    </div>
                                }
                                <center>
                                    <Button
                                        className="btn btn-primary"
                                        onClick={() => handleContinue(index)}
                                    >
                                        {localization.continue}{' '}
                                        {/*<img src="../images/arrow-right.png" alt="" />*/}
                                    </Button>
                                </center>
                            </ModalPop>
                        </div>
                    </CardSection>
                )
            })}

            <div className="col-md-12 col-sm-12 col-xs-12">
                <ConstantInput
                    label={localization.remark}
                    type="text"
                    value={''}
                    handleChange={(val) =>
                    { setFormRemark(val)
                       window.localStorage.assets_remark =  val
                    }
                    }
                    isStarRequired={true}
                    value={formRemark}
                />
            </div>
            <center>
                <Button
                    className="btn btn-primary"
                    onClick={handleSubmitForm}
                >
                    {localization.submit}{' '}
                </Button>
            </center>

            {material?.length <= 0 &&
                <div>
                    <img src={Images?.NoData} alt="" width="100%" />
                </div>
            }
        </Layout>
    );
};

export default MaterialAction;
